const product = {
  page: 1,
  take: 10,
  reserved: true,
  search: '',
  select: [
    'code',
    'name',
    'createdAt',
    'id',
    'shortID',
    'avatar',
    'status',
    'totalProductObject',
    'entitySubCategory.id',
    'entitySubCategory.name',
    'entityCategory.id',
    'entityCategory.displayName',
    'subCategory.id',
    'subCategory.name',
    'category.id',
    'category.name',
    'owner.id',
    'owner.avatar',
    'owner.displayName',
    'owner.type',
    'comboProducts.id',
    'coBuyProducts.id',

    'productOptions.id',
    'option.id',
    'option.content',
    'color.id',
    'color.code',
  ],
  relations: [
    'entitySubCategory',
    'entitySubCategory.entityCategory',
    'subCategory',
    'subCategory.category',
    'owner',
    'comboProducts',
    'coBuyProducts',
    'productOptions',
    'productOptions.option',
    'productOptions.option.color',
    'entityProducts',
  ],
  order: { name: 'createdAt', value: 0 },
};

const collaboratorProduct = {
  page: 1,
  take: 10,
  search: '',
  select: [
    'id',
    'status',
    'createdAt',
    'status',
    'entitySubCategory.id',
    'entitySubCategory.name',
    'entityCategory.id',
    'entityCategory.displayName',
    'entityProductID',
    'entitySubCategory.id',
    'entitySubCategory.name',
    'entityCategory.id',
    'entityCategory.displayName',
    'entityProduct.id',
    'entityProduct.totalProductObject',
    'entity.id',
    'entity.type',
    'entity.avatar',
    'entity.slug',
    'entity.displayName',
    'entity.type',
    'product.id',
    'product.code',
    'product.slug',
    'product.name',
    'product.createdAt',
    'product.shortID',
    'product.avatar',
    'product.status',
    'product.totalProductObject',
  ],
  relations: [
    'entitySubCategory',
    'entitySubCategory.entityCategory',
    'entityProduct',
    'entityProduct.product',
    'entityProduct.entity',
  ],
  order: { name: 'createdAt', value: 0 },
};

const productBase = {
  relations: [
    'productProductObjects',
    'productProductObjects.productObject',
    'productProductObjects.productObject.area',
    'productProductObjects.productObject.product',
    'productProductObjects.productObject.product.owner',
    'productMedias',
    'productMedias.media',
    'productCertifications',
    'productCertifications.organization',
    'productCertifications.certification',
    'productQuestions',
    'ward',
  ],
};

const entityProductBase = {
  relations: [
    'product',
    'entity',
    'product.productMedias',
    'product.productMedias.media',
    'product.productCertifications',
    'product.productCertifications.organization',
    'product.productCertifications.certification',
    'product.productQuestions',
    'product.ward',
  ],
};

export const initProductQuery = {
  select: [
    'id',
    'code',
    'name',
    'status',
    'avatar',
    'price',
    'wholesalePrice',
    'wholesalePriceUnit',
    'createdAt',
    'unitPrefix',
    'unitWeight',
    'unitPostfix',
    'wholesaleUnit',
  ],
  order: { createdAt: 0 },
  page: 1,
  take: 10,
};

export { product, collaboratorProduct, productBase, entityProductBase };
